export default {

    data: function() {
    
        return {
            is: {
                initialised: false,
                loading: true,
                empty: true,
                failed: false
            },
            filter: {},
            params: {},
            api: '',
            collection: []
        }
    
    },

    created: function() {
    
        this.load()
    
    },
    
    watch: {
    
        filter: {
        
            deep: true,

            handler: function() {

                this.load()
            
            }

        }
    
    },

    methods: {
    
        load: function() {

            this.is.loading = true

            var params = this.$util.copy(this.params)

            this.$_.each(this.filter, function(value, key) {
            
                if (value !== null) params[key] = value
            
            })

            if (this.is.loading) this.$api.cancel()
        
            this.$api.get(this.api, params).then(function(json) {

                this.collection = json.collection 

                if(this.afterLoad) this.afterLoad(json)

                this.is.empty = (this.collection.length) ? false : true

                this.is.initialised = true
            
                this.is.loading = false
            
            }.bind(this), function() {

                this.collection = []

                this.is.empty = true
                this.is.loading = false
                this.is.initialised = true
                this.is.failed = true
            
            }.bind(this))
        
        }
        
    }

}